import * as _ from 'lodash';
import { FormEvent } from 'react'
import { Alert, Col, ControlLabel, Form, FormControl, FormGroup, Panel, Radio, Row } from 'react-bootstrap'
import { IListItem, IPostTransplantRejection, IRecipientProfilePostTransplantData } from '@nkr/models/index'
import { IValidation } from './validation';
import MaskedInput from 'react-maskedinput';
import styled from 'styled-components';
import Creatinine from './creatinine'
import GraftStatus from './graft-status';
import PatientStatus from './patient-status';
import GraftRejectionFailure from './graft-failure-rejection';

const BodyWrapper = styled(Panel.Body)`
    .form-horizontal .control-label {
        text-align: right;
    }
`;

interface IProps {
    data: IRecipientProfilePostTransplantData,
    rejectionEpisodeList: IPostTransplantRejection[],
    validation: IValidation,
    donorRelationList: IListItem[],
    desensitizationList: IListItem[],
    graftFailureReasonList: IListItem[],
    onChange: (data: IRecipientProfilePostTransplantData) => void,
    onAddRejectionEpisode: () => void,
    onEditRejectionEpisode: (rejectionId: number) => void,
    onDeleteRejectionEpisode: (rejectionId: number) => void,
    onUnDeleteRejectionEpisode: (rejectionId: number) => void
}

const Details = (props: IProps) => {
    const handleDataChange = (e: FormEvent<FormControl & HTMLSelectElement & HTMLInputElement>) => {
        let data = _.cloneDeep(props.data);
        let { name, value } = e.currentTarget;

        if (name == 'unosCPRA') {
            data.unosCPRA = value;
        }

        if (name == 'wasPreviouslySensitized') {
            if (parseInt(value) == 1) {
                data.wasPreviouslySensitized = true;
            }

            if (parseInt(value) == 0) {
                data.wasPreviouslySensitized = false;
            }

            if (parseInt(value) == -1) {
                data.wasPreviouslySensitized = null;
            }
        }

        if (name == 'coldIschemicHours') {
            data.coldIschemicHours = parseInt(value);
        }

        if (name == 'coldIschemicMinutes') {
            data.coldIschemicMinutes = parseInt(value);
        }

        if (name == 'packagingRemovalDateTime') {
            data.packagingRemovalDateTime = value;
        }

        if (name == 'reperfusionDateTime') {
            data.reperfusionDateTime = value;
        }

        if (name == 'immediateKidneyFunction') {
            if (parseInt(value) == 1) {
                data.immediateKidneyFunction = true;
            }

            if (parseInt(value) == 0) {
                data.immediateKidneyFunction = false;
            }

            if (parseInt(value) == -1) {
                data.immediateKidneyFunction = null;
            }
        }

        if (name == 'donorsUnosId') {
            data.donorsUnosId = value;
        }

        if (name == 'graftSurvival') {
            if (parseInt(value) == 1) {
                data.graftSurvival = true;
            }

            if (parseInt(value) == 0) {
                data.graftSurvival = false;
            }

            if (parseInt(value) == -1) {
                data.graftSurvival = null;
            }
        }

        if (name == 'graftFailureDate') {
            data.graftFailureDate = value;
        }

        if (name == 'graftFailureReason') {
            data.graftFailureReason = value;
        }

        if (name == 'graftFailureReasonOther') {
            data.graftFailureReasonOther = value;
        }

        if (name == 'rejectionDueToNonCompliance') {
            data.rejectionDueToNonCompliance = parseInt(value);
        }

        if (name == 'hadDelayedGraftFunction') {
            if (parseInt(value) == 1) {
                data.hadDelayedGraftFunction = true;
            }

            if (parseInt(value) == 0) {
                data.hadDelayedGraftFunction = false;
            }

            if (parseInt(value) == -1) {
                data.hadDelayedGraftFunction = null;
            }
        }

        if (name == 'primaryNonFunction') {
            if (parseInt(value) == 1) {
                data.primaryNonFunction = true;
            }

            if (parseInt(value) == 0) {
                data.primaryNonFunction = false;
            }

            if (parseInt(value) == -1) {
                data.primaryNonFunction = null;
            }
        }

        if (name == 'donatedBy') {
            data.donatedBy = parseInt(value);
        }

        if (name == 'isAlive') {
            data.isAlive = parseInt(value) == 1;
        }

        if (name == 'deathDate') {
            data.deathDate = value;
        }

        if (name == 'primaryCauseOfDeath') {
            data.primaryCauseOfDeath = value;
        }

        if (name == 'secondaryCauseOfDeath') {
            data.secondaryCauseOfDeath = value;
        }

        if (name == 'rejectionEpisodes') {
            data.rejectionEpisodes = parseInt(value);
        }

        if (name == 'rejectionEpisodeDetail') {
            data.rejectionEpisodeDetail = value;
        }

        if (name == 'lostToFollowup') {
            data.lostToFollowup = parseInt(value) == 1;
        }

        if (name == 'wasDesensitized') {
            if (parseInt(value) == 1) {
                data.wasDesensitized = true;
            }

            if (parseInt(value) == 0) {
                data.wasDesensitized = false;
            }

            if (parseInt(value) == -1) {
                data.wasDesensitized = null;
            }
        }

        if (name == 'desensitizationType') {
            data.desensitizationType = value;
        }

        props.onChange(data);
    };

    const handleDesensitizationChange = (index: number, value: number) => {
        let data = _.cloneDeep(props.data);

        data.desensitization[index] = value;

        props.onChange(data);
    };

    let coldIschemicHours = [
        { value: -1, label: 'None' },
    ];

    for (let n = 0; n <= 30; n++) {
        coldIschemicHours.push({ value: n, label: n.toString() });
    }

    let coldIschemicMinutes = [];

    for (let n = 0; n <= 59; n++) {
        coldIschemicMinutes.push({ value: n, label: n.toString() });
    }

    return (
        <>
            <Panel>
                <Panel.Heading>Details</Panel.Heading>
                <BodyWrapper>
                    <Row>
                        <Col xs={12} lg={3}>
                            <FormGroup validationState={props.validation.unosCPRA == false ? 'error' : null}>
                                <ControlLabel>UNOS CPRA at Time of Transplant</ControlLabel>
                                <FormControl
                                    name='unosCPRA'
                                    style={{ width: 300 }}
                                    value={props.data.unosCPRA}
                                    onChange={handleDataChange}
                                />
                            </FormGroup>
                        </Col>

                        <Col xs={12} lg={3}>
                            <FormGroup>
                                <ControlLabel>Wait Time in Days</ControlLabel>
                                <div className='form-control-static-disabled' style={{ width: '50%' }}>{props.data.exportableDaysInNkr}</div>
                            </FormGroup>
                        </Col>

                        <Col xs={12} lg={3}>
                            <FormGroup validationState={props.validation.wasPreviouslySensitized == false ? 'error' : null}>
                                <ControlLabel>Recipient was Previously Sensitized?</ControlLabel>
                                <div className='form-control-static'>
                                    <Radio id='wasPreviouslySensitizedYes' name='wasPreviouslySensitized' inline value={1} checked={props.data.wasPreviouslySensitized == true} onChange={handleDataChange}>Yes</Radio>
                                    <Radio id='wasPreviouslySensitizedNo' name='wasPreviouslySensitized' inline value={0} checked={props.data.wasPreviouslySensitized == false} onChange={handleDataChange}>No</Radio>
                                    <Radio id='wasPreviouslySensitizedUnknown' name='wasPreviouslySensitized' inline value={-1} checked={props.data.wasPreviouslySensitized == null} onChange={handleDataChange}>Unknown</Radio>
                                </div>
                            </FormGroup>
                        </Col>

                        <Col xs={12} lg={3}>
                            <FormGroup validationState={props.validation.coldIschemicHours == false ? 'error' : null}>
                                <ControlLabel>Cold Ischemic Time</ControlLabel>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <FormControl
                                        componentClass='select'
                                        name='coldIschemicHours'
                                        style={{ width: 'initial' }}
                                        value={props.data.coldIschemicHours}
                                        onChange={handleDataChange}
                                    >
                                        {coldIschemicHours.map((i, index) =>
                                            <option key={'ischemicHour-' + i.value} value={i.value}>{i.label}</option>
                                        )}
                                    </FormControl>
                                    <span>hrs</span>
                                    <FormControl
                                        componentClass='select'
                                        name='coldIschemicMinutes'
                                        style={{ width: 'initial' }}
                                        value={props.data.coldIschemicMinutes ?? 0}
                                        onChange={handleDataChange}
                                    >
                                        {coldIschemicMinutes.map((i, index) =>
                                            <option key={'ischemicMin-' + i.value} value={i.value}>{i.label}</option>
                                        )}
                                    </FormControl>
                                    <span>min</span>
                                </div>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} lg={3}>
                            <FormGroup>
                                <ControlLabel>Re-perfusion Date/Time</ControlLabel>
                                <MaskedInput
                                    name='reperfusionDateTime'
                                    className='form-control'
                                    mask='11/11/1111 11:11'
                                    placeholder='mm/dd/yyyy hh:mm'
                                    value={props.data.reperfusionDateTime}
                                    onChange={handleDataChange}
                                />
                            </FormGroup>
                        </Col>

                        <Col xs={12} lg={3}>
                            <FormGroup>
                                <ControlLabel>Did the Kidney Function Immediately?</ControlLabel>
                                <div style={{ minHeight: 34 }}>
                                    <Radio id='immediateKidneyFunctionYes' name='immediateKidneyFunction' inline value={1} checked={props.data.immediateKidneyFunction == true} onChange={handleDataChange}>Yes</Radio>
                                    <Radio id='immediateKidneyFunctionNo' name='immediateKidneyFunction' inline value={0} checked={props.data.immediateKidneyFunction == false} onChange={handleDataChange}>No</Radio>
                                    <Radio id='immediateKidneyFunctionUnknown' name='immediateKidneyFunction' inline value={-1} checked={props.data.immediateKidneyFunction == null} onChange={handleDataChange}>Unknown</Radio>
                                </div>
                            </FormGroup>
                        </Col>

                        <Col xs={12} lg={3}>
                            <FormGroup validationState={props.validation.donorUnosId == false ? 'error' : null}>
                                <ControlLabel>UNOS Donor ID of Kidney Received for this Recipient</ControlLabel>
                                <FormControl
                                    name='donorsUnosId'
                                    style={{ width: '100px' }}
                                    value={props.data.donorsUnosId}
                                    onChange={handleDataChange} />
                                <span style={{ marginLeft: '5px', fontSize: 12 }}>*only required if missing from donors record</span>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} lg={3}>
                            <FormGroup>
                                <ControlLabel>Relationship of Paired Donor to Recipient</ControlLabel>
                                <FormControl
                                    componentClass='select'
                                    name='donatedBy'
                                    style={{ width: 300 }}
                                    value={props.data.donatedBy}
                                    onChange={handleDataChange}
                                >
                                    <option value={0}>Please Select...</option>
                                    {props.donorRelationList.map((donor, index) =>
                                        <option key={`swap-${index}`} value={donor.id}>{donor.description}</option>
                                    )}
                                </FormControl>
                            </FormGroup>
                        </Col>

                        <Col xs={12} lg={3}>
                            <FormGroup>
                                <ControlLabel>Patient Lost To Followup?</ControlLabel>
                                <div style={{ minHeight: 34 }}>
                                    <Radio inline name='lostToFollowup' value={1} checked={props.data.lostToFollowup != null ? props.data.lostToFollowup : false} onChange={handleDataChange}>Yes</Radio>
                                    <Radio inline name='lostToFollowup' value={0} checked={props.data.lostToFollowup != null ? !props.data.lostToFollowup : false} onChange={handleDataChange}>No</Radio>
                                </div>
                            </FormGroup>
                        </Col>
                    </Row>
                </BodyWrapper>
            </Panel>

            <Row>
                <Col xs={12} sm={6} lg={6} style={{ verticalAlign: 'top' }}>
                    <Panel>
                        <Panel.Heading>Graft Status</Panel.Heading>
                        <Panel.Body>
                            <GraftStatus
                                data={props.data}
                                validation={props.validation}
                                onChange={handleDataChange}
                            />
                        </Panel.Body>
                    </Panel>
                </Col>

                <Col xs={12} sm={6} lg={6} style={{ verticalAlign: 'top' }}>
                    <Panel>
                        <Panel.Heading>Rejection</Panel.Heading>
                        <Panel.Body>
                            <GraftRejectionFailure
                                data={props.data}
                                rejectionEpisodeList={props.rejectionEpisodeList}
                                rejectionEpisodeDetailValid={props.validation.rejectionEpisodeDetail}
                                onChange={handleDataChange}
                                onAddRejectionEpisode={props.onAddRejectionEpisode}
                                onEditRejectionEpisode={props.onEditRejectionEpisode}
                                onDeleteRejectionEpisode={props.onDeleteRejectionEpisode}
                                onUnDeleteRejectionEpisode={props.onUnDeleteRejectionEpisode}
                            />
                        </Panel.Body>
                    </Panel>
                </Col>
            </Row>

            <Row>
                <Col xs={12} sm={6} lg={6} style={{ verticalAlign: 'top' }}>
                    <Panel>
                        <Panel.Heading>Creatinine Details</Panel.Heading>
                        <Panel.Body>
                            <Creatinine
                                data={props.data}
                                validation={props.validation}
                                onChange={props.onChange} />
                        </Panel.Body>
                    </Panel>
                </Col>

                <Col xs={12} sm={6} lg={6} style={{ verticalAlign: 'top' }}>
                    <Form horizontal>
                        <FormGroup>
                            <Col xs={12} lg={12}>
                                <Panel>
                                    <Panel.Heading>Patient Status</Panel.Heading>
                                    <Panel.Body>
                                        <PatientStatus
                                            data={props.data}
                                            validation={props.validation}
                                            onChange={handleDataChange}
                                        />
                                    </Panel.Body>
                                </Panel>
                            </Col>
                        </FormGroup>

                        <FormGroup>
                            <Col sm={12}>
                                <Panel>
                                    <Panel.Heading>
                                        <Panel.Title>Desensitization</Panel.Title>
                                    </Panel.Heading>
                                    <Panel.Body>
                                        <Alert bsStyle='warning' bsSize='sm'>
                                            Please do not enter induction therapies in the desensitization fields; this includes IVIG, Thymo, and ATG.
                                        </Alert>

                                        <Form horizontal>
                                            <FormGroup validationState={props.validation.wasDesensitized == false ? 'error' : null}>
                                                <Col xs={12} sm={12} lg={6} componentClass={ControlLabel}>
                                                    Recipient was desensitized?
                                                    <div style={{ fontSize: 12, paddingLeft: 15, fontWeight: 'normal' }}>(beyond induction therapy)</div>
                                                </Col>
                                                <Col xs={12} sm={12} lg={5}>
                                                    <div style={{ minHeight: 34 }}>
                                                        <Radio id='wasDesensitizedYes' name='wasDesensitized' inline value={1} checked={props.data.wasDesensitized == true} onChange={handleDataChange}>Yes</Radio>
                                                        <Radio id='wasDesensitizedNo' name='wasDesensitized' inline value={0} checked={props.data.wasDesensitized == false} onChange={handleDataChange}>No</Radio>
                                                        <Radio id='wasDesensitizedUnknown' name='wasDesensitized' inline value={-1} checked={props.data.wasDesensitized == null} onChange={handleDataChange}>Unknown</Radio>
                                                    </div>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup validationState={props.validation.desensitizationType == false ? 'error' : null}>
                                                <Col xs={12} sm={12} lg={6} componentClass={ControlLabel}>
                                                    Type of Desensitization Utilized:
                                                </Col>
                                                <Col xs={12} sm={12} lg={6}>
                                                    <FormControl
                                                        name='desensitizationType'
                                                        style={{ width: 300 }}
                                                        value={props.data.desensitizationType}
                                                        onChange={handleDataChange}
                                                    />
                                                </Col>
                                            </FormGroup>

                                            {props.data.desensitization.map((desensitization, index) =>
                                                <FormGroup key={'des-' + index}>
                                                    <Col xs={12} sm={12} lg={6} componentClass={ControlLabel}>
                                                        Desensitization Treatment {index + 1}:
                                                    </Col>
                                                    <Col xs={12} sm={12} lg={6}>
                                                        <FormControl
                                                            name={'desensitization' + index}
                                                            componentClass='select'
                                                            style={{ width: 300 }}
                                                            value={desensitization}
                                                            onChange={(e: FormEvent<FormControl & HTMLSelectElement>) => handleDesensitizationChange(index, parseInt(e.currentTarget.value))}
                                                        >
                                                            {props.desensitizationList.map((desensitization, index) =>
                                                                <option key={`desensitization-${index}`} value={desensitization.id}>{desensitization.description}</option>
                                                            )}
                                                        </FormControl>
                                                    </Col>
                                                </FormGroup>
                                            )}
                                        </Form>
                                    </Panel.Body>
                                </Panel>
                            </Col>
                        </FormGroup>
                    </Form>
                </Col>
            </Row>
        </>
    );
}

export default Details;